import moment from "moment";
export default [
   { id: parseInt(moment().format("YYYY")) - 5, name: parseInt(moment().format("YYYY")) - 5 },
   { id: parseInt(moment().format("YYYY")) - 4, name: parseInt(moment().format("YYYY")) - 4 },
   { id: parseInt(moment().format("YYYY")) - 3, name: parseInt(moment().format("YYYY")) - 3 },
   { id: parseInt(moment().format("YYYY")) - 2, name: parseInt(moment().format("YYYY")) - 2 },
   { id: parseInt(moment().format("YYYY")) - 1, name: parseInt(moment().format("YYYY")) - 1 },
   { id: parseInt(moment().format("YYYY")), name: parseInt(moment().format("YYYY")) },
   { id: parseInt(moment().format("YYYY")) + 1, name: parseInt(moment().format("YYYY")) + 1 },
   { id: parseInt(moment().format("YYYY")) + 2, name: parseInt(moment().format("YYYY")) + 2 },
   { id: parseInt(moment().format("YYYY")) + 3, name: parseInt(moment().format("YYYY")) + 3 },
   { id: parseInt(moment().format("YYYY")) + 4, name: parseInt(moment().format("YYYY")) + 4 },
   { id: parseInt(moment().format("YYYY")) + 5, name: parseInt(moment().format("YYYY")) + 5 },
];